import React from 'react';
import Icon, { IconProps } from './Icon';

const CashIcon: React.FC<IconProps> = ({ size = 24, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <rect
        x="2"
        y="6"
        width="20"
        height="12"
        rx="2"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <circle
        cx="12"
        cy="12"
        r="3"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M6 9V9.01M18 15V15.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export default CashIcon;
